export const binaryId = {
  type: 'number',
  minimum: 1,
  maximum: 2 ** 32 / 2 - 1,
};
